import http from '../util/http.js'

export const ApplyUseList = (text,page,pageSize = 10) => http.get('/applyUse/list',{text,page,pageSize})
export const ApplyUseDetele = (id) => http.get('/applyUse/delete',{id})
export const ApplyUseSave = (params) => http.post('/applyUse/save',params)
